<template>
  <ArrowPathIcon v-if="pending" class="inline-block size-[1em] animate-spin" />
</template>

<script lang="ts" setup>
import ArrowPathIcon from "@/icons/heroicons/arrow-path-micro.svg";

defineProps<{ pending: boolean }>();
</script>
